import { render, staticRenderFns } from "./CohortsEdit.vue?vue&type=template&id=b7545620&scoped=true&"
import script from "./CohortsEdit.vue?vue&type=script&lang=js&"
export * from "./CohortsEdit.vue?vue&type=script&lang=js&"
import style0 from "./CohortsEdit.vue?vue&type=style&index=0&id=b7545620&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7545620",
  null
  
)

export default component.exports